export enum AlertType {
	OPTION_TERM_CHANGED = 'CET',
	PAYMENT_TERM_CREATED_MANUALLY = 'MPT',
	QUICK_RESERVATION = 'FETA',
	OBJECT_CANCELLED_BY_OSKAR = 'COO',
}
